import { NativeAction } from "./HandleWs";

export const userHabit = (phonecfg, screenCode) => {
  // if(phonecfg.phoneOS === "ANDROID") {
  // if(phonecfg.phoneOS === "ANDROID" && parseInt(phonecfg.version.split('.')[2]) > 9) {
  //     try {
  //         userhabitSetScreen(screenCode);
  //     } catch (error) {
  //         console.log("### userHabit Err ANDROID : ", error);
  //     }
  // } else if (phonecfg.phoneOS === "IOS" && parseInt(phonecfg.version.split('.')[2]) > 5) {
  //     try {
  //         // userhabitSetScreen(screenCode);
  //         NativeAction(phonecfg, "userHabit", screenCode);
  //     } catch (error) {
  //         console.log("### userHabit Err IOS : ", error);
  //     }
  // }
};